import * as React from 'react';
import {OnlineClaimRequest} from "@falcon/services";
import {getModifiedMobileNumber} from "../../CommonFunctions";

interface IProps {
    onlineClaimRequest: OnlineClaimRequest;
    showUrgentClaimSection: boolean;
}

export class ClaimSubmissionPanel extends React.Component<IProps> {

    constructor(props: IProps) {
        super(props);
    }

    public render(): React.ReactNode {
        return (
            <div className="section-panel">
                <div className="mb-4">
                    <img className="d-block m-auto" src="/img/Flow-green-tick-desktop.svg" alt="Tick icon" height={100}/>
                </div>
                <h1>We received your claim request. What's next?</h1>
                <p>
                    We've sent an email confirming claims details to
                    <span className="font-weight-bold long-word"> {this.props.onlineClaimRequest.contactEmail}</span>
                </p>
                <p>
                    Our claims teams will call you back on
                    <span className="font-weight-bold"> {getModifiedMobileNumber(this.props.onlineClaimRequest.contactMobile)} </span>
                    within 48 hours during normal office hours.
                </p>
                <p>Our normal office hours are Monday - Friday 8am - 8pm Saturdays 8am - 5pm.</p>
                {this.props.showUrgentClaimSection &&
                    <p>
                        If you need to speak to us before that please use the urgent claim reporting phone number
                        <a href="tel:+44 8000 304 897" className="mb-4 a-bold" aria-label="Phone number +44 8000 304 897"> 08000 304 897 </a>
                        From abroad
                        <a href="tel:+44 120 284 8509" className="mb-4 a-bold" aria-label="Phone number +44 120 284 8509"> (+44) 0120 284 8509</a>
                    </p>
                }
            </div>
        )
    }
}



// WEBPACK FOOTER //
// ./src/components/claims/ClaimSubmissionPanel.tsx